import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { backend } from './../axios/backend';
import { useAppContext } from './../context/AppContext';
import { Tag } from './../types/tag';

export const useTags = () => {
  const { user } = useAppContext();

  const cacheKey = ['tags', user.username];
  const query = useQuery(cacheKey, async () => {
    const response = await backend.get<Tag[]>('tag/my');
    return response.data;
  });

  const tagMap = useMemo(() => {
    return (
      query.data?.reduce((tagMap: Record<string, Tag>, tag) => {
        tagMap[tag.name] = tag;
        return tagMap;
      }, {}) || {}
    );
  }, [query.data]);

  return {
    ...query,
    cacheKey,
    tagMap,
  };
};
